<template>
  <modal
    id="modalDescontos"
    titulo="FINANCEIRO.DESCONTO"
    :exibir="exibir"
    :campos="$refs"
    :tamanho="'lg'"
    @fechar="fecharModal"
  >
    <form-descontos
      :form="form"
      @form-desconto="obterDesconto"
      @refs="getRefs"
    />

    <template #modal-footer>
      <div class="d-flex justify-content-between w-100">
        <b-button variant="secondary" @click="fecharModal">
          {{ $t('GERAL.FECHAR') }}
        </b-button>
        <b-button variant="primary" @click="salvar">
          {{ $t('GERAL.SALVAR') }}
        </b-button>
      </div>
    </template>
  </modal>
</template>

<script>
// Utils & Aux:
import helpers from '@/common/utils/helpers';
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';

// Service & Models:
import DescontosService from '@/common/services/descontos/descontos.service';

// Components:
import Modal from '@/components/modal/Modal';
import FormDescontos from './Form';


const REAL = 'R$';
const PORCENTAGEM = '%';

export default {
  props: {
    exibir: { type: Boolean, default: false },
    id: { type: String, default: null },
  },
  components: {
    Modal,
    FormDescontos,
  },
  data() {
    return {
      desconto: {},
      refs: [],
      form:{
        id: null,
        descricao: '',
        tipoValor: null,
        valor: null,
        dataValidade: null,
        tipoDesconto: null,
        historicoLancamentoId: null,
        historicoLancamentoAplicaDescontoId: null,
        percentual: null,
      },
      tiposValor: [
          {
            value: PORCENTAGEM,
            text: 'Porcentagem - %',
          },
          {
            value: REAL,
            text: 'Reais - R$',
          },
        ],
    };
  },
  watch: {
    'exibir'(value) {
      if(value){
        this.limparCampos();
        this.getDescontoPorId();
      } 
    },
  },
  methods: {
    // FUNÇÕES VALIDAÇÃO FORMULÁRIO:
    getRefs(refs) {
      this.refs = refs;
    },
    validarFormulario() {
      return helpers.validarFormulario(this.refs);
    },
    obterDesconto(descontoForm) {
      this.desconto = descontoForm;
    },
    // FUNÇÕES MODAL:
    fecharModal() {
      this.$emit('fechar');
    },
    salvar() {
      if (!this.validarFormulario()) return;
      if(this.form.tipoValor == REAL){
        this.form.percentual = null;
      }else{
        this.form.percentual = this.form.valor;
        this.form.valor = null;
      }
      // Adiciona o 'historicoFinanceiro' pq no criar/editar a chave tá diferente no back:
      this.form.historicoFinanceiro = this.form.historicoFinanceiroId;
      this.$emit('salvar', this.form);
    },
    getDescontoPorId() {
      if(this.id){
        this.$store.dispatch(START_LOADING);
        DescontosService.obterPorId(this.id).then(({ data }) => {
          this.form.id = data.id;
          this.form.descricao = data.descricao;
          this.form.valor = (data.valor ?? data.percentual) || data.percentual;
          this.form.dataValidade = data.dataValidade;
          this.form.tipoDesconto = data.tipoDesconto;
          this.form.historicoLancamentoId = data.historicoLancamentoId;
          this.form.historicoLancamentoAplicaDescontoId = data.historicoLancamentoAplicaDescontoId;

          if(data.valor != 0 && data.valor != null && data.valor != undefined){
            this.form.tipoValor = REAL;
          }else{
            this.form.tipoValor = PORCENTAGEM;
          }
           
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });

        return;
      }
    },
    limparCampos() {
      this.form = {
        id: null,
        descricao: '',
        tipoValor: null,
        valor: null,
        dataValidade: null,
        tipoDesconto: null,
        historicoLancamentoId: null,
        historicoLancamentoAplicaDescontoId: null,
      };
    },
  },
};
</script>
